import { Filters } from './filters';

const FilterLabelTranslationKeys = {
    [Filters.USAGE]: 'catalog-filters-usage-select-label',
    [Filters.WIDTH]: 'catalog-configurator-width-select-label',
    [Filters.HEIGHT]: 'catalog-configurator-height-select-label',
    [Filters.DIAMETER]: 'catalog-configurator-diameter-select-label',
    [Filters.SPEED_INDEX]: 'catalog-configurator-speed-index-select-label',
    [Filters.LOAD_INDEX]: 'catalog-configurator-load-index-select-label',
    [Filters.MANUFACTURER]: 'catalog-filters-manufacturer-select-label',
    [Filters.MODEL]: 'catalog-filters-model-select-label',
    [Filters.VEHICLE_TYPE]: 'catalog-filters-vehicle-type-select-label',
    [Filters.RUN_FLAT]: 'catalog-filters-runflat-label',
    [Filters.FREE_FITTING]: 'catalog-filters-free-fitting-label',
    [Filters.BUY_4_PAY_3]: 'catalog-filters-buy-4-pay3-label',
    [Filters.CLEARANCE]: 'catalog-filters-clearance-label',
    [Filters.INSTANT_CASH]: 'catalog-filters-instant-cash-label',
    [Filters.PRICE_MIN]: 'catalog-filters-price-min-select-label',
    [Filters.PRICE_MAX]: 'catalog-filters-price-max-select-label',
    [Filters.POSTCODE]: 'catalog-configurator-postcode-input-label',
    [Filters.WHEEL_MODEL]: 'catalog-filters-wheel-model-select-label',
    [Filters.WHEEL_DIAMETER]: 'catalog-filters-wheel-diameter-select-label',
    [Filters.WHEEL_WIDTH]: 'catalog-filters-wheel-width-select-label',
    [Filters.WHEEL_STUDS]: 'catalog-filters-wheel-studs-select-label',
    [Filters.WHEEL_PCD]: 'catalog-filters-wheel-pcd-select-label',
    [Filters.WHEEL_FINISH]: 'catalog-filters-wheel-finish-select-label',
    [Filters.VEHICLE_MAKE]: 'vehicle-configurator-make-select-label',
    [Filters.VEHICLE_TYRES]: 'vehicle-configurator-tyres-select-label',
    [Filters.TECHNOLOGY]: 'catalog-filters-technology-select-label',
    [Filters.LABEL_NOISE]: 'catalog-filters-label-noise-select-label',
    [Filters.LABEL_WET_GRIP]: 'catalog-filters-label-wet-grip-select-label',
    [Filters.LABEL_FUEL_EFFICIENCY]: 'catalog-filters-label-fuel-efficiency-select-label',
    [Filters.UTQG_TREADWEAR_GROUP]: 'catalog-filters-utqg-treadwear-group-select-label',
    [Filters.UTQG_TRACTION]: 'catalog-filters-utqg-traction-select-label',
    [Filters.UTQG_TEMPERATURE]: 'catalog-filters-utqg-temperature-select-label',
    [Filters.DISCOUNT_INSTANT_CASH_50]: 'catalog-filters-discount-instant-cash-50-label',
    [Filters.DISCOUNT_INSTANT_CASH_80]: 'catalog-filters-discount-instant-cash-80-label',
    [Filters.DISCOUNT_INSTANT_CASH_100]: 'catalog-filters-discount-instant-cash-100-label',
    [Filters.DISCOUNT_INSTANT_CASH_120]: 'catalog-filters-discount-instant-cash-120-label',
    [Filters.DISCOUNT_INSTANT_CASH_150]: 'catalog-filters-discount-instant-cash-150-label',
    [Filters.DISCOUNT_INSTANT_CASH_160]: 'catalog-filters-discount-instant-cash-160-label',
    [Filters.DISCOUNT_INSTANT_CASH_200]: 'catalog-filters-discount-instant-cash-200-label',
    [Filters.DISCOUNT_INSTANT_CASH_250]: 'catalog-filters-discount-instant-cash-250-label',
    [Filters.DISCOUNT_INSTANT_CASH_300]: 'catalog-filters-discount-instant-cash-300-label',
    [Filters.DISCOUNT_5_OFF]: 'catalog-filters-discount-5-off-label',
    [Filters.DISCOUNT_10_OFF]: 'catalog-filters-discount-10-off-label',
    [Filters.DISCOUNT_15_OFF]: 'catalog-filters-discount-15-off-label',
    [Filters.DISCOUNT_20_OFF]: 'catalog-filters-discount-20-off-label',
    [Filters.DISCOUNT_25_OFF]: 'catalog-filters-discount-25-off-label',
    [Filters.PROMO_GIFT_CARD_50]: 'catalog-filters-promo-gift-card-50-label',
    [Filters.PROMO_GIFT_CARD_80]: 'catalog-filters-promo-gift-card-80-label',
    [Filters.PROMO_GIFT_CARD_100]: 'catalog-filters-promo-gift-card-100-label',
    [Filters.PROMO_GIFT_CARD_130]: 'catalog-filters-promo-gift-card-130-label',
    [Filters.PROMO_GIFT_CARD_150]: 'catalog-filters-promo-gift-card-150-label',
    [Filters.PROMO_GIFT_CARD_200]: 'catalog-filters-promo-gift-card-200-label',
    [Filters.PROMO_GIFT_CARD_250]: 'catalog-filters-promo-gift-card-250-label',
    [Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]: 'catalog-filters-customer-review-dry-traction-rating-select-label',
    [Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]: 'catalog-filters-customer-review-low-noise-rating-select-label',
    [Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]: 'catalog-filters-customer-review-ride-comfort-rating-select-label',
    [Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]: 'catalog-filters-customer-review-steering-response-rating-select-label',
    [Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]: 'catalog-filters-customer-review-tread-wear-rating-select-label',
    [Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]: 'catalog-filters-customer-review-value-for-money-rating-select-label',
    [Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]: 'catalog-filters-customer-review-wet-traction-rating-select-label',

    [Filters.QUALITY_SEGMENT_PREMIUM]: 'catalog-filters-quality-segment-premium-label',
    [Filters.QUALITY_SEGMENT_VALUE]: 'catalog-filters-quality-segment-value-label',
    [Filters.QUALITY_SEGMENT_BUDGET]: 'catalog-filters-quality-segment-budget-label',
    [Filters.SEASON]: 'catalog-filters-season-select-label',
    [Filters.EV]: 'catalog-filters-ev-select-label',
};

export { FilterLabelTranslationKeys };